import Hero from "../../components/Hero";
import SEO from "../../seo/SEO";

export default function HomePage() {
  return (
    <div>
      <SEO
        title="Δικηγορικό Γραφείο Χαλντούν Σόρτογλου"
        description="Χαλντούν Σόρτογλου | Δικηγόρος | Κομοτηνή"
      />
      <Hero />
    </div>
  );
}
